var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18758 11.3334C1.08456 11.3334 0.98384 11.3028 0.898173 11.2456C0.812506 11.1884 0.745736 11.107 0.706308 11.0118C0.66688 10.9167 0.656565 10.8119 0.67667 10.7109C0.696774 10.6098 0.746393 10.517 0.819251 10.4442L10.4441 0.819255C10.5418 0.721567 10.6743 0.666687 10.8124 0.666687C10.9506 0.666687 11.0831 0.721567 11.1808 0.819255C11.2784 0.916942 11.3333 1.04943 11.3333 1.18759C11.3333 1.32574 11.2784 1.45823 11.1808 1.55592L1.55591 11.1809C1.50758 11.2293 1.45017 11.2677 1.38696 11.2938C1.32375 11.32 1.25599 11.3334 1.18758 11.3334Z",
    fill: "#696F7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8124 11.3334C10.744 11.3334 10.6762 11.32 10.613 11.2938C10.5498 11.2677 10.4924 11.2293 10.4441 11.1809L0.819223 1.55592C0.721536 1.45823 0.666656 1.32574 0.666656 1.18759C0.666656 1.04943 0.721536 0.916942 0.819223 0.819255C0.916909 0.721567 1.0494 0.666687 1.18755 0.666687C1.3257 0.666687 1.45819 0.721567 1.55588 0.819255L11.1807 10.4442C11.2536 10.517 11.3032 10.6098 11.3233 10.7109C11.3434 10.8119 11.3331 10.9167 11.2937 11.0118C11.2542 11.107 11.1875 11.1884 11.1018 11.2456C11.0161 11.3028 10.9154 11.3334 10.8124 11.3334Z",
    fill: "#696F7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGray);
export default __webpack_public_path__ + "static/media/cross-gray.0e2d874124f0e57f5509db27c748b68a.svg";
export { ForwardRef as ReactComponent };